import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

// ─────────────────────────────────────────────────────────────────────────────
// Quién y qué, en vez de dos números.
//
// La auditoría guarda `userId: 180` y `deviceId: 28` porque es lo que manda el worker, pero
// leyendo la tabla eso obliga a ir a buscar a mano de quién se trata. Aquí se enseña el
// nombre —o el correo, si no hay nombre— y el número queda a un lado, chiquito, que sigue
// haciendo falta para cruzar con Traccar o pasárselo a alguien.
//
// Si el backend no pudo resolverlo, se muestra el número pelado: inventar un nombre sería
// peor que no tenerlo.
// ─────────────────────────────────────────────────────────────────────────────

const Numero: React.FC<{ id?: number | string | null }> = ({ id }) => (
  <Typography variant="body2" fontFamily="monospace" color="text.secondary">
    {id ?? '—'}
  </Typography>
);

export const Persona: React.FC<{
  id?: number | string | null;
  nombre?: string | null;
  correo?: string | null;
}> = ({ id, nombre, correo }) => {
  if (!nombre && !correo) return <Numero id={id} />;
  const principal = nombre || correo;
  return (
    <Tooltip title={`Usuario ${id}${correo && nombre ? ` · ${correo}` : ''}`}>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" noWrap sx={{ maxWidth: 160 }}>{principal}</Typography>
        <Typography variant="caption" color="text.secondary" fontFamily="monospace">#{id}</Typography>
      </Box>
    </Tooltip>
  );
};

export const Equipo: React.FC<{
  id?: number | string | null;
  nombre?: string | null;
  imei?: string | null;
}> = ({ id, nombre, imei }) => {
  if (!nombre) return <Numero id={id} />;
  return (
    <Tooltip title={`Equipo ${id}${imei ? ` · IMEI ${imei}` : ''}`}>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" noWrap sx={{ maxWidth: 170 }}>{nombre}</Typography>
        <Typography variant="caption" color="text.secondary" fontFamily="monospace">#{id}</Typography>
      </Box>
    </Tooltip>
  );
};
